import ToggleButtonGroup, {
  ToggleOption,
} from '../../../../components/Forms/Buttons/ToggleButtonGroup';
import SearchInputField from '../../../../components/Forms/Input/SearchInputField';
import SelectField from '../../../../components/Forms/Input/SelectField';
import { RestaurantTableStatus } from '../../../../types/restaurant/RestaurantTableTypes';

export type TableActiveFilter = 'ALL' | 'ACTIVE' | 'INACTIVE';

interface DiningRoomOption {
  id: number;
  name: string;
}

interface TableFiltersProps {
  search: string;
  roomFilter: number;
  statusFilter: 'ALL' | RestaurantTableStatus;
  activeFilter: TableActiveFilter;
  diningRooms: DiningRoomOption[];
  onSearchChange: (value: string) => void;
  onRoomChange: (roomId: number) => void;
  onStatusChange: (status: 'ALL' | RestaurantTableStatus) => void;
  onActiveChange: (active: TableActiveFilter) => void;
}

const TableFilters = ({
  search,
  roomFilter,
  statusFilter,
  activeFilter,
  diningRooms,
  onSearchChange,
  onRoomChange,
  onStatusChange,
  onActiveChange,
}: TableFiltersProps) => {
  const activeOptions = [
    { value: 'ALL', label: 'Todas' },
    { value: 'ACTIVE', label: 'Activas' },
    { value: 'INACTIVE', label: 'Inactivas' },
  ] satisfies ToggleOption<TableActiveFilter>[];

  return (
    <div className="grid grid-cols-1 gap-4 border-b border-stroke p-5 dark:border-strokedark lg:grid-cols-[1fr_260px_260px_auto] lg:items-end">
      <div className="md:pb-5">
        <SearchInputField
          label="Buscar"
          name="tableSearch"
          value={search}
          iconKey="search"
          placeholder="Buscar por código o nombre..."
          withMargin={false}
          onChange={(event) => onSearchChange(event.target.value)}
        />
      </div>

      <SelectField
        label="Salón"
        name="roomFilter"
        value={roomFilter}
        iconKey="store"
        options={[
          { value: 0, label: 'Todos los salones' },
          ...diningRooms.map((room) => ({
            value: room.id,
            label: room.name,
          })),
        ]}
        onChange={(event) => onRoomChange(Number(event.target.value))}
      />

      <SelectField
        label="Estado operativo"
        name="tableStatusFilter"
        value={statusFilter}
        iconKey="status"
        options={[
          { value: 'ALL', label: 'Todos los estados' },
          { value: 'FREE', label: 'Libre' },
          { value: 'OCCUPIED', label: 'Ocupada' },
          { value: 'RESERVED', label: 'Reservada' },
          { value: 'CLEANING', label: 'En limpieza' },
          { value: 'OUT_OF_SERVICE', label: 'Fuera de servicio' },
        ]}
        onChange={(event) =>
          onStatusChange(event.target.value as 'ALL' | RestaurantTableStatus)
        }
      />

      <ToggleButtonGroup
        value={activeFilter}
        options={activeOptions}
        onChange={onActiveChange}
        className="mb-5"
      />
    </div>
  );
};

export default TableFilters;
